var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6201 9.62H12.3701C11.9601 9.62 11.6201 9.28 11.6201 8.87C11.6201 8.46 11.9601 8.12 12.3701 8.12H17.6201C18.0301 8.12 18.3701 8.46 18.3701 8.87C18.3701 9.28 18.0401 9.62 17.6201 9.62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12006 10.38C6.93006 10.38 6.74006 10.31 6.59006 10.16L5.84006 9.41001C5.55006 9.12001 5.55006 8.64001 5.84006 8.35001C6.13006 8.06001 6.61006 8.06001 6.90006 8.35001L7.12006 8.57001L8.84006 6.85001C9.13006 6.56001 9.61006 6.56001 9.90006 6.85001C10.1901 7.14001 10.1901 7.62001 9.90006 7.91001L7.65006 10.16C7.51006 10.3 7.32006 10.38 7.12006 10.38Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6201 16.62H12.3701C11.9601 16.62 11.6201 16.28 11.6201 15.87C11.6201 15.46 11.9601 15.12 12.3701 15.12H17.6201C18.0301 15.12 18.3701 15.46 18.3701 15.87C18.3701 16.28 18.0401 16.62 17.6201 16.62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12006 17.38C6.93006 17.38 6.74006 17.31 6.59006 17.16L5.84006 16.41C5.55006 16.12 5.55006 15.64 5.84006 15.35C6.13006 15.06 6.61006 15.06 6.90006 15.35L7.12006 15.57L8.84006 13.85C9.13006 13.56 9.61006 13.56 9.90006 13.85C10.1901 14.14 10.1901 14.62 9.90006 14.91L7.65006 17.16C7.51006 17.3 7.32006 17.38 7.12006 17.38Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.8b4245776336273d6a7096c258706c58.svg";
export { ForwardRef as ReactComponent };